module.exports = __webpack_public_path__ + "static/hmd-411bd07e31a0aa54b09d54a74868224a.svg";